import React from 'react';
type SectionHeadingProps = {
  children: React.ReactNode;
  eyebrow?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  children,
  eyebrow,
  align = 'center'
}: SectionHeadingProps) {
  return <header className={align === 'center' ? 'text-center' : 'text-left'} data-id="element-154" data-mp="3f25c14r7ckko">
      {eyebrow ? <p className="mb-2 text-[12px] font-semibold uppercase tracking-[0.16em] text-gold-500" data-id="element-155" data-mp="3k187bxhdrcfg">
          {eyebrow}
        </p> : null}
      <h2 className="font-display text-[26px] font-semibold leading-[1.25] tracking-[-0.01em] text-ink-900" data-id="element-156" data-mp="bmgdylhcadwh">
        {children}
      </h2>
    </header>;
}